export default "__VITE_ASSET__OicHZpov__"